module.exports = __webpack_public_path__ + "img/i-coquin.6a3f5ded.svg";